import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import ItineraryPeriodicMarginDrawer from "components/drawer/ItineraryPeriodicMarginDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import ShowHideButton from "components/table/ShowHideButton";
import useToggleDrawer from "hooks/useToggleDrawer";

const ItineraryPeriodicMarginTable = ({
  overrideMarginData,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
    useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <ItineraryPeriodicMarginDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {overrideMarginData?.map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs font-medium">
              {data.city_name}
            </TableCell>
            <TableCell className="text-center text-xs font-medium">
              {data.start_date
                ? new Date(data.start_date).toLocaleDateString("en-GB")
                : "-"}
            </TableCell>

            <TableCell className="text-center text-xs font-medium">
              {data.end_date
                ? new Date(data.end_date).toLocaleDateString("en-GB")
                : "-"}
            </TableCell>

            {Object.entries(data.margin_details || {}).map(
              ([vehicleId, vehicle]) => (
                <TableCell key={vehicleId} className="text-center text-xs">
                  {vehicle.fee}
                </TableCell>
              ),
            )}

            <TableCell className="text-sm text-center">
              <ShowHideButton
                id={data?.id}
                status={data?.is_active}
                Loading={true}
              />
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  // id={data.id_city}
                  id={data.id}
                  isSubmitting={isSubmitting}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default ItineraryPeriodicMarginTable;
